module.exports = __webpack_public_path__ + "img/on_hold.048e4f9e.svg";